import {Component, HostListener, Injector} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {DetailComponent} from '../shared/detail/detail.component';
import {DialogService} from '../shared/dialog/dialog.service';
import {MasterDetailActionSource, MasterDetailHub} from '../shared/master-detail/master-detail-hub.service';
import {ValidationService} from "../shared/cml-forms/validation.service";


@Component({
    selector: 'cml-vysledek-vypoctu-vykazu-detail',
    templateUrl: '../shared/detail/detail.component.html',
    styleUrls: ['../shared/detail/detail.component.scss'],
    standalone: false
})
export class VysledekVypoctuVykazuDetailComponent extends DetailComponent
{
  constructor(router: Router,
              route: ActivatedRoute,
              injector: Injector,
              dialogService: DialogService,
              masterDetailHub: MasterDetailHub,
              validationService: ValidationService,
              private dialog: MatDialog) {
    super(router, route, injector, dialogService, masterDetailHub, validationService);
  }
  @HostListener('window:keydown.escape', ['$event'])
  onKeyDownHandler(event: KeyboardEvent)
  {
    if (!(this.dialog.openDialogs.length > 0))
    {
      this.detailService.close();
    }
  }

  override async deleteEntity(redirect: boolean = true): Promise<void> {
    await super.deleteEntity(false);
    this.masterDetailHub.emitRefresh(MasterDetailActionSource.master)

  }
}
